import React from 'react';
import {
    StyleSheet,
    View,
    TouchableOpacity,
    ScrollView,
    TouchableWithoutFeedback
  } from 'react-native'
import css from './Style'
import MyText from './MyText';
import MyDatePicker from './MyDatePicker';
import MyTextInput from './MyTextInput';
import { MaterialIcons, Entypo, Feather } from '@expo/vector-icons'; 

import axios from 'axios';

import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';

let filteredData = [];
const sizes = [35, 60, 90, 125, 135, 80, 85, 100, 140, 125, 125, 90];

const tableHeader = ['ID', 'Ship Name', 'Datetime \nSubmitted', 'Datetime \nRequested Delivery', 'Port', 'Location', 'IMO', 'Status', 'Scheduled \nCollection', 'Datetime \nCollected', 'Actions'];
// const tableData = [
//     ['123456', 'Blue Star Delos',       '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Submitted', '31-Jan-2023 11:00', ''],
//     ['213456', 'Blue Star Paros',       '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Validated', '31-Jan-2023 11:00', ''],
//     ['312456', 'Blue Star Mykonos',     '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Route Scheduled 7-Jan-2022 14:00', '31-Jan-2023 11:00', ''],
//     ['312456', 'Blue Star Mykonos',     '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Driver Arrived', '31-Jan-2023 11:00', ''],
//     ['412356', 'Aida Blue',             '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Waste Collected', '31-Jan-2023 11:00', ''],
//     ['512356', 'Aida Blue',             '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Waste Segregated', '31-Jan-2023 11:00', ''],
//     ['612345', 'Aida Blue',             '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Certificate Issued', '31-Jan-2023 11:00', ''],
//     ['612345', 'Aida Blue',             '31-Jan-2023 11:00', '31-Jan-2023 11:00', 'Κ.Λ. Περαία', 'XXXXXXX', 'XXXXXXX', 'Cancelled', '31-Jan-2023 11:00', ''],
// ];

const MyRequests = (props) => {
    const pageRef = React.useRef();
    const tableRef = React.useRef();

    const [from, setFrom] = React.useState(null);
    const [to, setTo] = React.useState(null);
    const [type, setType] = React.useState('all');
    const [searchText, setSearchText] = React.useState('');
    const [sort, setSort] = React.useState({column: 2, ascending: false}); //# column does not count, 0 is the ID

    const [tableData, setTableData] = React.useState([]);
    const [data, setData] = React.useState(tableData);

    const [initialLoadDone, setInitialLoadDone] = React.useState(false);

    const GetTableData = () => {
        setTableData([]);
        setInitialLoadDone(false);
        axios.get('/api/myRequests.php')
        .then((res) => {
            let result = [];
            res.data.forEach(row => {
                let scheduledCollection = '';
                if(row.route_update && row.route_update.length > 0){
                    scheduledCollection = new Date(row.route_update[0].datetime);
                }

                let collectionDatetime = '';
                if(row.waste_collection?.collectedOn){
                    collectionDatetime = new Date(row.waste_collection.collectedOn);
                }
                
                result.push([row.id, row.data.shipName, row.requested_at, row.data.requestedDelivery, row.data.portOfDelivery, row.data.location, row.data.imo, row.status, scheduledCollection, collectionDatetime, '']);
            })
            setTableData(result);
            setInitialLoadDone(true);
        })
    }
    React.useEffect(() => {
        const unsubscribe = props.navigation.addListener('focus', () => {
            if(pageRef){
                pageRef.current.scrollTo({
                    x: 0,
                    y: 0,
                    animated: false,
                });
            }
            if(tableRef){
                tableRef.current.scrollTo({
                    x: 0,
                    y: 0,
                    animated: false,
                });
            }
            GetTableData();
        });
        return unsubscribe;
      }, []);

    React.useEffect(() => {
        FilterData();
    }, [type, searchText, tableData, from, to]);

    React.useEffect(() => {
        SortData();
    }, [sort]);

    const FormatDatetime = (dt) => {
        if(!dt)
            return '';
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const padLeft = (num) => {
            if(num < 10)
                return '0'+num;
            return num;
        }
        const date = new Date(dt);
        return padLeft(date.getDate()) + '-' + months[date.getMonth()] + '-' + date.getFullYear() + ' ' + padLeft(date.getHours()) + ':' + padLeft(date.getMinutes());
    }

    const Searched = (text) => {
        setSearchText(text);
    }

    const changeType = (type) => {
        setType(type);
    }

    const ChangeSort = (sortColumn) => {
        setSort(prev => (
            {
                column: sortColumn,
                ascending: prev.column==sortColumn?(!prev.ascending):true
            }
        ));
    }

    const Cancel = (id) => {
        props.openModal("Warning", "Are you sure you want to Cancel this request?\nPlease note that by cancelling the request, you will not be able to recover it.", () => {
            const data = {
                id,
                status: 'Cancelled'
            }
            axios.post('/api/editRequestStatus.php', data)
            .then((res) => {
                props.openModal("Success", "Your request has been successfully cancelled.");
                GetTableData();
            })
        });
    }
    
    const Bullet = (bulletProps) => {
        const orange = '#efa270';
        const yellow = '#fed354';
        const blue = '#1aa0eb';
        const green = '#23a43f';
        const red = '#e32112';
        let color = '';
        let text = bulletProps?.text?.toString()??'';

        if(bulletProps.cellIndex == 11 && bulletProps.rowIndex > 0){
            return <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <TouchableOpacity onPress={() => props.navigation.navigate('Request Info', { id: bulletProps.id })}>
                    <MaterialIcons name="visibility" size={18} color="#461b6f" style={{marginRight: 10}} />
                </TouchableOpacity>
                {
                    bulletProps.status != 'Cancelled' && (bulletProps.status == 'Submitted' || bulletProps.status == 'Validated') &&
                    <TouchableOpacity onPress={() => props.navigation.navigate('Edit Request', { id: bulletProps.id })}>
                        <Entypo name="edit" size={14} color="#0d5cb4" style={{marginRight: 8}}/>
                    </TouchableOpacity>
                }
                {
                    bulletProps.status != 'Cancelled' && (bulletProps.status == 'Submitted' || bulletProps.status == 'Validated') &&
                    <TouchableOpacity onPress={() => Cancel(bulletProps.id)}>
                        <Feather name="x" size={18} color="#b10002" style={{marginRight: 10}}/>
                    </TouchableOpacity>
                }
            </View>;
        }
        if(!text){
            return <></>;
        }
        if(text.startsWith('Submitted') || text.startsWith('Validated')){
            color = orange;
        }
        else if(text.startsWith('Route') || text.startsWith('Driver')){
            color = yellow;
        }
        else if(text.startsWith('Waste')){
            color = blue;
        }
        else if(text.startsWith('Certificate')){
            color = green;
        }
        else if(text.startsWith('Cancel')){
            color = red;
        }
        if(bulletProps.rowIndex > 0 && (bulletProps.cellIndex == 3 || bulletProps.cellIndex == 4 || bulletProps.cellIndex == 9 || bulletProps.cellIndex == 10) ){
            text = <><MyText style={{fontSize: 0.001, color: 'transparent'}}>{text}</MyText>{FormatDatetime(text)}</>;
        }
        if(bulletProps.cellIndex == 8 && bulletProps.rowIndex > 0){
            return <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <View style={{width: 10, height: 10, borderRadius: 5, backgroundColor: color, marginRight: 5, marginTop: Platform.OS==='ios'?-1:1.5, overflow: 'hidden'}}></View>
                    <MyText style={{fontSize: 10}}>{text}</MyText>
                </View>
        }
        if(bulletProps.rowIndex == 0){
            return <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <MyText style={[styles.headerText, css.bold, {fontSize: 10}]}>{text}</MyText>
                    {
                        sort.column+1 == bulletProps.cellIndex &&
                        <View style={{position: 'absolute', right: -10}}>
                            <MaterialIcons style={{top: 0}} name={"keyboard-arrow-up"} size={18} color={sort.ascending?'white':'#461b6f'} />
                            <MaterialIcons style={{marginTop: -10}} name={"keyboard-arrow-down"} size={18} color={!sort.ascending?'white':'#461b6f'} />
                        </View>
                    }
                    {
                        sort.column+1 != bulletProps.cellIndex && bulletProps.cellIndex != 0 && (
                        <View style={{position: 'absolute', right: -10}}>
                            <MaterialIcons style={{top: 0}} name={"keyboard-arrow-up"} size={18} color="#d1d1d1" />
                            <MaterialIcons style={{marginTop: -10}} name={"keyboard-arrow-down"} size={18} color="#d1d1d1" />
                        </View>
                        )
                    }
                    </View>;
        }
        let textAlign = 'left';
        if(bulletProps.cellIndex == 0)
            textAlign = 'right';
        return <MyText style={{fontSize: 10, textAlign: textAlign}}>{text}</MyText>;
    }

    const render = (rowIndex, cellIndex, data, id, status) => {
        if(rowIndex == 0)
            return (
                <TouchableOpacity onPress={() => ChangeSort(cellIndex-1)}>
                    <View key={cellIndex} style={[styles.cell, styles.header, {width: sizes[cellIndex]}]}>
                        <Bullet rowIndex={rowIndex} cellIndex={cellIndex} text={data}/>
                    </View>
                </TouchableOpacity>
            );
        return <View key={cellIndex} style={[rowIndex%2?styles.even:styles.odd, styles.cell, {width: sizes[cellIndex]}]}><Bullet rowIndex={rowIndex} cellIndex={cellIndex} id={id} text={data} status={status}/></View>;
    }

    const FilterData = () => {
        filteredData = [];
        tableData.forEach((row, rowIndex) => {
            let addedRow = false;
            let fromDate = new Date();
            let toDate = new Date();
            if(from){
                fromDate = new Date(from);
                fromDate.setHours(0);
                fromDate.setMinutes(0);
            }
            if(to){
                toDate = new Date(to);
                toDate.setHours(23);
                toDate.setMinutes(59);
            }
            if(from && !to){
                if(new Date(row[2]).getTime() < fromDate.getTime())
                    return;
            }
            else if(!from && to){
                if(new Date(row[2]).getTime() > toDate.getTime())
                    return;
            }
            else if(from && to){
                if(new Date(row[2]).getTime() < fromDate.getTime() || new Date(row[2]).getTime() > toDate.getTime())
                    return;
            }

            // Datetime objects to ISO String in order for sorting to work
            if(row[9].toISOString)
                row[9] = row[9].toISOString();
            if(row[10].toISOString)
                row[10] = row[10].toISOString();

            row.forEach((cell, cellIndex) => {
                if(addedRow)
                    return;
                if(cell.toString().toLowerCase().includes(searchText.toLowerCase())){
                    let hasFilter = false;
                    if(type == 'all'){
                        hasFilter = true;
                    }
                    if(row[7].startsWith('Submitted') && type == 'new'){
                        hasFilter = true;
                    }
                    else if(row[7].startsWith('Validated') && type == 'new'){
                        hasFilter = true;
                    }
                    else if(row[7].startsWith('Route Scheduled') && type == 'scheduled'){
                        hasFilter = true;
                    }
                    else if(row[7].startsWith('Driver Arrived') && type == 'scheduled'){
                        hasFilter = true;
                    }
                    else if(row[7].startsWith('Waste Collected') && type == 'collected'){
                        hasFilter = true;
                    }
                    else if(row[7].startsWith('Waste Segregated') && type == 'segregated'){
                        hasFilter = true;
                    }
                    else if(row[7].startsWith('Certificate') && type == 'segregated'){
                        hasFilter = true;
                    }
                    if(hasFilter){
                        filteredData.push(row);
                        addedRow = true;
                    }
                    return;
                }
            })
        })
        SortData();
    }

    const SortData = () => {
        filteredData.sort((a, b) => {
            if (a[sort.column].toString() < b[sort.column].toString()) return sort.ascending ? -1 : 1;
            if (a[sort.column].toString() > b[sort.column].toString()) return sort.ascending ? 1 : -1;
            return 0;
        });
        let numbered = [['#', ...tableHeader]];
        filteredData.forEach((row, idx) => {
            numbered.push([(idx+1).toString(), ...row]);//.unshift(idx.toString()));
        })
        setData(numbered);
    }

  return (
    <ScrollView vertical ref={pageRef} nestedScrollEnabled={true} keyboardShouldPersistTaps={'handled'} contentContainerStyle={{flexShrink: 0, flexGrow: 1}} scrollEnabled={true}>
        <View style={[css.background, {paddingRight: 0}]}>
            <MyText style={[css.title, css.bold]}>
                My Requests
            </MyText>
            {/* <MyText style={css.subtitle}>
                Date
            </MyText> */}
            <View style={{marginTop: 15}}>
                <View style={{display: 'flex', flexDirection: 'row'}}>
                    <View style={{marginRight: 7.5, flexBasis: 127.5, flexGrow: 0, flexShrink: 0}}>
                        <MyDatePicker
                            onChange={setFrom}
                            value={from}
                            placeholder='From'
                        />
                    </View>
                    <View style={{flex: 1, flexBasis: 127.5, flexGrow: 0, flexShrink: 0}}>
                        <MyDatePicker
                            onChange={setTo}
                            value={to}
                            placeholder='To'
                        />
                    </View>
                </View>
            </View>
            <View style={{marginTop: 10}}>
                <View style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                <View style={css.filterButton}>
                    <TouchableOpacity onPress={() => changeType('all')}>
                            <View style={[css.smallButton, {backgroundColor: type=='all'?'#461b6f':'white'}]}>
                                <MyText style={[css.bold, css.smallButtonText, {color: type=='all'?'white':'#461b6f'}]}>
                                    All Requests
                                </MyText>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={css.filterButton}>
                        <TouchableOpacity onPress={() => changeType('new')}>
                            <View style={[css.smallButton, {backgroundColor: type=='new'?'#461b6f':'white'}]}>
                                <MyText style={[css.bold, css.smallButtonText, {color: type=='new'?'white':'#461b6f'}]}>
                                    New
                                </MyText>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={css.filterButton}>
                        <TouchableOpacity onPress={() => changeType('scheduled')}>
                            <View style={[css.smallButton, {backgroundColor: type=='scheduled'?'#461b6f':'white'}]}>
                                <MyText style={[css.bold, css.smallButtonText, {color: type=='scheduled'?'white':'#461b6f'}]}>
                                    Scheduled
                                </MyText>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={css.filterButton}>
                        <TouchableOpacity onPress={() => changeType('collected')}>
                            <View style={[css.smallButton, {backgroundColor: type=='collected'?'#461b6f':'white'}]}>
                                <MyText style={[css.bold, css.smallButtonText, {color: type=='collected'?'white':'#461b6f'}]}>
                                    Collected
                                </MyText>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={css.filterButton}>
                        <TouchableOpacity onPress={() => changeType('segregated')}>
                            <View style={[css.smallButton, {backgroundColor: type=='segregated'?'#461b6f':'white'}]}>
                                <MyText style={[css.bold, css.smallButtonText, {color: type=='segregated'?'white':'#461b6f'}]}>
                                    Segregated
                                </MyText>
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
            <View style={{display: 'flex', flexDirection: 'row', marginRight: 10, marginTop: 0, marginBottom: 10}}>
                {/* <MyText style={[{lineHeight: 33, marginRight: 10}, css.bold]}>Search</MyText> */}
                <MyTextInput icon='search' onChangeText={Searched} value={searchText} placeholder='Search...' style={{flexGrow: 0, flexShrink: 0, flexBasis: 232}}/>
            </View>
            <View style={{marginBottom: 50}}>
                <View style={{display: 'flex', flexDirection: 'row'}}>
                    <View style={{flexShrink: 0, flexGrow: 0, borderTopLeftRadius: 8, borderBottomLeftRadius: 8, overflow: 'hidden'}}>
                        {
                            data.map((rowData, rowIndex) => {
                                return (
                                    <View key={rowIndex} style={{display: 'flex', flexDirection: 'row'}}>
                                        {
                                            rowData.map((cellData, cellIndex) => {
                                                if(cellIndex >= 3)
                                                    return <></>;
                                                return render(rowIndex, cellIndex, cellData, rowData[1], rowData[8]);
                                            })
                                        }
                                    </View>
                                )
                            })
                        }
                    </View>
                    <ScrollView horizontal ref={tableRef}>
                        <View style={{marginRight: 20, borderTopRightRadius: 8, borderBottomRightRadius: 8, overflow: 'hidden'}}>
                            {
                                data.map((rowData, rowIndex) => {
                                    return (
                                        <View key={rowIndex} style={{display: 'flex', flexDirection: 'row'}}>
                                            {
                                                rowData.map((cellData, cellIndex) => {
                                                    if(cellIndex < 3)
                                                        return <></>;
                                                    return render(rowIndex, cellIndex, cellData, rowData[1], rowData[8]);
                                                })
                                            }
                                        </View>
                                    )
                                })
                            }
                        </View>
                    </ScrollView>
                </View>
                <View style={[styles.even, styles.cell, {textAlign: 'center', display: data.length==1?'flex':'none'}]}>
                    <MyText style={{textAlign: 'center'}}>
                        {initialLoadDone?'No requests found':'Loading...'}
                    </MyText>
                </View>
            </View>
        </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
    filterButton: {
        marginRight: 10,
        marginBottom: 10,
        flexBasis: 125,
        flexGrow: 0,
        flexShrink: 0
    },
    text: {
        padding: 10,
    },
    row: {
        flexDirection: 'row',
    },
    header: {
        backgroundColor: '#461b6f',
    },
    headerText: {
        color: 'white'
    },
    cell: {
        paddingVertical: 5,
        paddingHorizontal: 10,
        height: 45,
        borderWidth: 1,
        borderColor: 'white',
        fontSize: 10,
        display: 'flex',
        justifyContent: 'center'
    },
    even: {
        backgroundColor: '#ececec'
    },
    odd: {
        backgroundColor: '#F6F4F9'
    }
});

const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(MyRequests)